<template>
  <button ref="btn" @click="showIndicator" class="overflow-hidden relative elevated-button h-10 flex items-center justify-center
    transition-colors duration-200
    border border-gray-400
    font-bold
  focus:bg-apex-blue-200/20
     bg-transparent  rounded-[1.25rem]" :class="{
      'px-6': !($slots.icon),
      'pl-4 pr-6': $slots.icon
    }">


    <div v-if="$slots.icon"
      class="elevated-button__icon pr-2 flex items-center justify-center">
      <slot name="icon"></slot>
    </div>
    <slot></slot>

    <div ref="indicator" class="absolute z-10 opacity-0 elevated-button__indicator 
      left-0 w-5 h-5  rounded-full 
      bg-apex-blue-700/25
      transform-origin-center pointer-events-none">
    </div>
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter, RouteLocationNamedRaw } from 'vue-router'
const indicator = ref<HTMLElement | undefined>(undefined);
const btn = ref<HTMLElement | undefined>(undefined);

const props = defineProps<{
  to?: RouteLocationNamedRaw
}>()

const router = useRouter();
const showIndicator = (e: any) => {
  if (!indicator.value || !btn.value || indicator.value == undefined) return;

  const btnRect = btn.value.getBoundingClientRect();
  const clickX = e.clientX - btnRect.left;
  const clickY = e.clientY - btnRect.top;

  // set the center of the indicator to the click position
  indicator.value.style.left = `${clickX}px`;
  indicator.value.style.top = `${clickY}px`;

  // Center the indicator and scale it
  indicator.value.style.transform = 'translate(-50%, -50%) scale(10)';
  indicator.value.style.opacity = '1';


  setTimeout(() => {
    if (indicator.value != undefined) {
      indicator.value.style.opacity = '0';
      indicator.value.style.transform = 'translate(-50%, -50%) scale(0)';
    }

    if (props.to) {
      router.push(props.to);
    }

    btn.value?.blur();
  }, 250);
}
</script>

<style scoped>
.elevated-button__indicator {
  transition: opacity .25s, transform .25s;
}
</style>